import { useEffect, useState } from 'react'
import { Box, Fab, SwipeableDrawer, Typography } from '@mui/material'
import { useIsMobile } from 'hooks/screen/useIsMobile'
import { FilterList } from '@mui/icons-material'

interface FilterDrawerProps {
  FilterUI: React.ComponentType
  SortUI: React.ComponentType
}

export const FilterDrawer = ({ FilterUI, SortUI }: FilterDrawerProps) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const isMobile = useIsMobile()

  // Add event listener to close drawer when custom event is triggered
  useEffect(() => {
    const handleCloseDrawer = () => {
      setIsFilterOpen(false)
    }

    window.addEventListener('closeFilterDrawer', handleCloseDrawer)
    return () => {
      window.removeEventListener('closeFilterDrawer', handleCloseDrawer)
    }
  }, [])

  if (!isMobile) {
    return (
      <Box
        sx={{
          width: '300px',
          flexShrink: 0,
          position: 'sticky',
          top: 24,
          alignSelf: 'flex-start',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
          <SortUI />
        </Box>
        <FilterUI />
      </Box>
    )
  }

  return (
    <Box>
      <Fab
        variant='extended'
        size='medium'
        color='primary'
        aria-label='filter'
        onClick={() => setIsFilterOpen(true)}
        sx={{
          display: { xs: 'block', sm: 'none' },
          position: 'fixed',
          bottom: 16,
          left: 16,
          zIndex: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <FilterList sx={{ marginRight: 1 }} />
          <Typography variant='button'>Filter</Typography>
        </Box>
      </Fab>
      <SwipeableDrawer
        open={isFilterOpen}
        onOpen={e => {
          e.stopPropagation()
          setIsFilterOpen(true)
        }}
        onClose={e => {
          // Only close if click is on the backdrop
          if (e.target === e.currentTarget) {
            e.stopPropagation()
            setIsFilterOpen(false)
          }
        }}
        anchor='bottom'
        sx={{
          '& .MuiDrawer-paper': {
            maxHeight: '80vh',
            overflow: 'auto',
          },
        }}
        ModalProps={{
          keepMounted: true,
          disableAutoFocus: true,
          disableEnforceFocus: true,
        }}
      >
        <FilterUI />
      </SwipeableDrawer>
    </Box>
  )
}
